import { Heart } from "lucide-react";

const TIERS = [
  { min: 1000, label: "Patron", cls: "border-amber-300/60 text-amber-200 bg-amber-300/10" },
  { min: 500, label: "Champion", cls: "border-primary/60 text-primary bg-primary/10" },
  { min: 1, label: "Supporter", cls: "border-primary/40 text-primary bg-primary/[0.06]" },
];

export function supporterTier(total = 0) {
  return TIERS.find((t) => total >= t.min) || null;
}

export function SupporterBadge({ total = 0, supporter = false, className = "" }) {
  const tier = supporterTier(total) || (supporter ? TIERS[2] : null);
  if (!tier) return null;
  return (
    <span
      data-testid="supporter-badge"
      title={`Academy ${tier.label} — thank you for supporting the work`}
      className={`inline-flex items-center gap-1.5 text-[10px] uppercase tracking-widest font-mono px-2.5 py-1 rounded-full border ${tier.cls} ${className}`}
    >
      <Heart className="w-3 h-3 fill-current" /> {tier.label}
    </span>
  );
}
